import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header pb-0 border-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "btn btn-sm btn-icon btn-active-color-primary pull-end" }
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = {
  key: 0,
  class: "modal-body scroll-y mx-5 mx-xl-15 pt-0"
}
const _hoisted_8 = {
  key: 2,
  class: "modal-footer flex-center"
}

import { hideModal } from "@/core/helpers/dom";
import { computed, useAttrs } from "vue";


const __default__ = {
    inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Modal',
  props: {
    id: { default: "modal" },
    title: { default: undefined },
    customClass: { default: "mw-650px" },
    unwrapped: { type: Boolean, default: false }
  },
  emits: ["hide"],
  setup(__props: any, { emit: __emit }) {

const attrs = useAttrs();

const props = __props;

const rootAttrs = computed(() => {
    const { class: _class, ...rest } = attrs;
    return rest;
});

const dialogClasses = computed(() => ["modal-dialog", props.customClass, attrs.class]);



const emit = __emit;

const hide = () => {
    const modalEl = document.getElementById(props.id);
    const activeEl = document.activeElement as HTMLElement | null;

    // Prevent aria-hidden/focus conflicts when Bootstrap hides the modal.
    if (modalEl && activeEl && modalEl.contains(activeEl)) {
        activeEl.blur();
    }

    hideModal(props.id);
    emit("hide");
};

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _mergeProps({
      class: "modal fade",
      tabindex: "-1",
      id: props.id
    }, rootAttrs.value), [
      _createElementVNode("div", {
        class: _normalizeClass(dialogClasses.value)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                onClick: _withModifiers(hide, ["stop"])
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ])
          ]),
          (!_ctx.unwrapped)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _renderSlot(_ctx.$slots, "default", { key: 1 }),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 16, _hoisted_1)
  ]))
}
}

})